import {
  Component,
  ChangeDetectionStrategy,
  Input
} from '@angular/core';

@Component({
    selector: 'vshc-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    host: {
      '[class.is-animation-disabled]': 'disableAnimation'
    }
})
export class LogoComponent {
  @Input()
  full = false;

  @Input()
  hideText = false;

  @Input()
  disableAnimation = false;
}
